import { combineReducers } from 'redux';

import { artProductsReducer } from './reducers/artProducts';

export const artsReducer = combineReducers({
  artProducts: artProductsReducer,
});
